export default {
  GAC_REASON_CODE: 'reasonCode',
  GAC_REASON_CODE_DESCRIPTION: 'reasonCodeDescription',
  GAC_REASON_CODE_ISACTIVE: 'isActive',
  GAC_MODIFIED_BY: 'modifiedBy',
  GAC_MODIFY_DATE: 'modifiedDate',
  GAC_REASON_TIER: 'tier'
};
